<div *ngIf="showLoading" class="reward-detail-loading" aria-live="polite" aria-busy="true" role="alert" tabindex="2">
    <div class="loading-spinner">
        <div class="large progress" alt="Loading..." aria-label="Loading...">
            <div class="prog1">
                <div class="prog2"></div>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="partnerDetails.isStatic; else dynamicPartner">
    <div *ngIf="!showLoading">
        <app-promotion-info [isWebView]="isWebView" [partnerDetails]="partnerDetails"></app-promotion-info>

        <div class="promoLinkContainer mt-5 mb-5" *ngIf="isPromoCodeURL ; else staticCode">
            <div class="richtext parbase section">
                <div class="align-center">
                    <div class="promo-link-title">You must use this unique link to claim your offer</div>
                </div>
                <div class="align-center">
                    <a class="link-style" href="#" (click)="openURL()" (keypress)="openURL()" target="_blank" role="link"
                       [attr.aria-label]="isWebView ? 'Redeem offer for '+ partnerDetails.partnerName + ' opens in web view':'Redeem offer for ' + partnerDetails.partnerName + ' opens in a new tab'">{{ displayParnterPromoURL }}</a>
                </div>
            </div>
        </div>
        <ng-template #staticCode>
            <div class="mt-5 mb-5">
                <div class="promoCodeContainer">
                    <div class="code-copy-title">Paste this code to redeem</div>
                    <div class="code-copy">
                        {{ displayPromoCode }}
                    </div>
                    <div class="redeem-code-button">
                        <button type="button" class="btn btn-xl btn-primary body-text no-partner-footer__button"
                                (click)="copyCodeRedeem()"
                                (keypress)="copyCodeRedeem()"
                                role="link"
                                [attr.aria-label]="isWebView ? 'Paste this code and redeem offer for ' + partnerDetails.partnerName + ' opens in web view':'Paste this code and redeem offer for ' + partnerDetails.partnerName + ' opens in a new tab'">
                            Redeem now
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>
        <app-promotion-faq [isWebView]="isWebView" [partnerDetails]="partnerDetails"></app-promotion-faq>
        <app-promotion-terms [isWebView]="isWebView" [partnerDetails]="partnerDetails"></app-promotion-terms>
    </div>
</ng-container>
<ng-template #dynamicPartner>
    <div *ngIf="!showLoading">
        <ng-container *ngIf="isErorrInAPI">
            <div class="no-partner-container" role="alert" aria-live="assertive">
                <div class="no-partner-logo-container">
                    <img aria-hidden="true" class="partner-logo"
                         src="/ocrp-rewards-ui/dist/assets/images/icon/page-load-error.svg" alt="Error loading page"/>
                </div>
                <div class="no-partner-body">
                    <h2 class="no-partner-heading-size">Page couldn’t load</h2>
                    <p class="no-partner-description-text"> {{ apiErrorMessage }} </p>
                </div>
                <div class="no-partner-footer">
                    <button type="button" class="btn btn-xl btn-primary body-text no-partner-footer__button" role="link"
                            (click)="openDealsPage()" (keypress)="openDealsPage()" aria-label="View deals">
                        View deals
                    </button>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="!isErorrInAPI">
            <ng-container *ngIf="!partnerOfferAvailable">
                <div class="no-partner-container" role="alert" aria-live="polite">
                    <div class="no-partner-logo-container">
                        <img aria-hidden="true" class="partner-logo"
                             src="/ocrp-rewards-ui/dist/assets/images/icon/empty-partners.svg" alt=""/>
                    </div>
                    <div class="no-partner-body">
                        <h2 class="no-partner-heading-size">No partner offers at this time</h2>
                        <p class="no-partner-description-text">We still have a ton of other deals you could check
                            out.</p>
                    </div>
                    <div class="no-partner-footer">
                        <button type="button" class="btn btn-xl btn-primary body-text no-partner-footer__button"
                                role="link"
                                (click)="openDealsPage()" (keypress)="openDealsPage()" aria-label="View deals">
                            View deals
                        </button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="partnerOfferAvailable">
                <app-promotion-info [isWebView]="isWebView" [partnerDetails]="partnerDetails"></app-promotion-info>
                <div class="promoLinkContainer" *ngIf="isPromoCodeURL">
                    <div class="richtext parbase section">
                        <div class="align-center">
                            <div class="promo-link-title">You must use this unique link to claim your offer</div>
                        </div>
                        <div class="align-center">
                            <a class="link-style" href="#" (click)="openURL()" (keypress)="openURL()" target="_blank" role="link"
                                [attr.aria-label]="isWebView ? 'Redeem offer for '+ partnerDetails.partnerName + ' opens in web view':'Redeem offer for ' + partnerDetails.partnerName + ' opens in a new tab'">{{ displayParnterPromoURL }}</a>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="promoCodeContainer" *ngIf="!isPromoCodeURL">
                        <div class="code-copy-title">Paste this code to redeem</div>
                        <div class="code-copy">{{ displayPromoCode }}
                            <div>
                                <button type="button" 
                                class="btn btn-xl btn-primary body-text no-partner-footer__button"
                                (click)="copyCodeRedeem()"
                                (keypress)="copyCodeRedeem()" 
                                role="link"
                                [attr.aria-label]="isWebView ? 'Paste this code and redeem offer for ' + partnerDetails.partnerName + ' opens in web view':'Paste this code and redeem offer for ' + partnerDetails.partnerName + ' opens in a new tab'">
                                Redeem now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <app-promotion-faq [isWebView]="isWebView" [partnerDetails]="partnerDetails"></app-promotion-faq>
                <app-promotion-terms [isWebView]="isWebView" [partnerDetails]="partnerDetails"></app-promotion-terms>
            </ng-container>
        </ng-container>
    </div>
</ng-template>
